[
  {
    "id": "nmea2000",
    "namn": "NMEA 2000",
    "anslutning": "buss",
    "agaren": null,
    "styrning": "nej",
    "status": "stöds",
    "vag": "officiell",
    "kalla": "nmea2000"
  },
  {
    "id": "masterbus",
    "namn": "Mastervolt MasterBus",
    "anslutning": "buss",
    "agaren": "Navet ansluts till MasterBus med en egen kabel. Frågorna till enheterna slås på med sudo batkoll-nav masterbus fraga pa",
    "styrning": "granskad",
    "status": "stöds",
    "vag": "egen",
    "kalla": "masterbus"
  },
  {
    "id": "home_assistant",
    "namn": "Home Assistant",
    "anslutning": "lokalt",
    "agaren": "Installera navet som en app i Home Assistant, eller ge navet en token för Home Assistant",
    "styrning": "granskad",
    "status": "stöds",
    "vag": "officiell",
    "kalla": "ha"
  },
  {
    "id": "ecowitt_ha",
    "namn": "Ecowitt via Home Assistant",
    "anslutning": "lokalt",
    "agaren": "Lägg till Ecowitts integration i Home Assistant. Navet hittar entiteterna själv",
    "styrning": "nej",
    "status": "stöds",
    "vag": "officiell",
    "kalla": "ha"
  },
  {
    "id": "bthome",
    "namn": "BTHome",
    "anslutning": "bluetooth",
    "agaren": "En givare med kryptering behöver sin nyckel. Den skrivs in på navet med sudo batkoll-nav givare nyckel, och visas aldrig i appen",
    "styrning": "nej",
    "status": "stöds",
    "vag": "officiell",
    "kalla": "bluetooth"
  },
  {
    "id": "ruuvi",
    "namn": "Ruuvi",
    "anslutning": "bluetooth",
    "agaren": null,
    "styrning": "nej",
    "status": "stöds",
    "vag": "officiell",
    "kalla": "bluetooth"
  },
  {
    "id": "inkbird",
    "namn": "Inkbird",
    "anslutning": "bluetooth",
    "agaren": null,
    "styrning": "nej",
    "status": "stöds",
    "vag": "egen",
    "kalla": "bluetooth"
  },
  {
    "id": "ecowitt",
    "namn": "Ecowitt via gatewayen",
    "anslutning": "lokalt",
    "agaren": "Ställ in Customized i gatewayen till navets adress, port 4791 och sökvägen /ecowitt",
    "styrning": "nej",
    "status": "stöds",
    "vag": "officiell",
    "kalla": "ecowitt"
  },
  {
    "id": "nobo",
    "namn": "Nobø Hub",
    "anslutning": "lokalt",
    "agaren": "Skriv in hubbens serienummer på navet med sudo batkoll-nav serie",
    "styrning": "granskad",
    "status": "stöds",
    "vag": "officiell",
    "kalla": "nobo"
  },
  {
    "id": "forbrukare",
    "namn": "Förbrukare av bränsle",
    "anslutning": "buss",
    "agaren": "Skriv förbrukningen i l/h under Inställningar, och koppla en signal för när förbrukaren går",
    "styrning": "nej",
    "status": "beta",
    "vag": "egen",
    "kalla": null
  },
  {
    "id": "victron_gx",
    "namn": "Victron GX (MQTT)",
    "anslutning": "lokalt",
    "agaren": "Slå på MQTT on LAN i GX-enheten (Settings → Services), och skriv in GX-enhetens adress i appen. Navet läser bara, och skriver aldrig till Victron",
    "styrning": "nej",
    "status": "beta",
    "vag": "officiell",
    "kalla": "victron"
  },
  {
    "id": "victron_ble",
    "namn": "Victron över Bluetooth (Instant Readout)",
    "anslutning": "bluetooth",
    "agaren": "Hämta nyckeln för varje enhet i VictronConnect och skriv in den i appen. Den förseglas till navet i webbläsaren, och molnet kan inte läsa den",
    "styrning": "nej",
    "status": "beta",
    "vag": "officiell",
    "kalla": "bluetooth"
  },
  {
    "id": "homey",
    "namn": "Homey Pro",
    "anslutning": "lokalt",
    "agaren": "Skapa en API-nyckel i Homeys webbapp (Inställningar → API-nycklar) med bara rätten att se enheter, och klistra in den i appen. Den förseglas till navet i webbläsaren, och molnet kan inte läsa den",
    "styrning": "nej",
    "status": "beta",
    "vag": "officiell",
    "kalla": "homey"
  },
  {
    "id": "shelly",
    "namn": "Shelly direkt",
    "anslutning": "lokalt",
    "agaren": null,
    "styrning": "nej",
    "status": "planerad",
    "vag": "officiell",
    "kalla": null
  },
  {
    "id": "matter",
    "namn": "Matter",
    "anslutning": "lokalt",
    "agaren": null,
    "styrning": "nej",
    "status": "planerad",
    "vag": "officiell",
    "kalla": null
  },
  {
    "id": "knx",
    "namn": "KNX (KNXnet/IP)",
    "anslutning": "lokalt",
    "agaren": null,
    "styrning": "nej",
    "status": "planerad",
    "vag": "officiell",
    "kalla": null
  },
  {
    "id": "fordon",
    "namn": "Fordon",
    "anslutning": "moln",
    "agaren": null,
    "styrning": "nej",
    "status": "planerad",
    "vag": "officiell",
    "kalla": null
  },
  {
    "id": "vader_bat",
    "namn": "Väderstation ombord (RS-485 eller NMEA 0183)",
    "anslutning": "buss",
    "agaren": null,
    "styrning": "nej",
    "status": "planerad",
    "vag": "officiell",
    "kalla": null
  },
  {
    "id": "teltonika",
    "namn": "Teltonika (router)",
    "anslutning": "lokalt",
    "agaren": null,
    "styrning": "nej",
    "status": "planerad",
    "vag": "officiell",
    "kalla": null
  }
]
